module.exports = __webpack_public_path__ + "img/DigiCampus Only Logo.f6bbd907.png";